import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as resultCodes from "../constants/resultCodes";
import * as componentTypes from "../constants/componentTypes";
import * as helper from "../constants/helper";
import * as messageHelper from "../helpers/messageHelper";
import * as formatHelper from "../helpers/formatHelper";
import * as windowService from "./windowService";
import * as handlers from "../constants/handlers";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.HELPER_SET_CONFIGURATION:
            if (response.result !== resultCodes.HELPER_RESULT_OK || response.data !== true) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            return [];
        case handlers.HELPER_IS_ONLINE:
            if (response.result !== resultCodes.HELPER_RESULT_OK) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_HELPER_IS_ONLINE,
                    payload: {
                        isOnline: response.data
                    }
                }
            ];
        case handlers.HELPER_SEND_ERROR_REPORT:
            if (response.result !== resultCodes.HELPER_RESULT_OK) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            let reportBugActions = [
                {
                    type: actionTypes.SET_BLOCKED_UI,
                    payload: {
                        blocked: false
                    }
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.BUG_REPORT_MODAL
                    }
                },
                messageHelper.getSuccessMessageAction("flashMessage.bugReportSent")
            ];

            if (state.module.gammaSoftware) {
                reportBugActions.push({
                    type: actionTypes.SET_ACTIVE_TAB,
                    payload: {
                        tabId: componentTypes.DEFAULT_TAB_ID
                    }
                });
            }

            return reportBugActions;
        case handlers.HELPER_SAVE_LOG_FILES:
            if (response.result !== resultCodes.HELPER_RESULT_OK) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            if (!response.data) {
                return [
                    {
                        type: actionTypes.SET_BLOCKED_UI,
                        payload: {
                            blocked: false
                        }
                    },
                    messageHelper.getErrorMessageAction("flashMessage.problemWithFileExport")
                ];
            }

            return [
                {
                    type: actionTypes.SET_BLOCKED_UI,
                    payload: {
                        blocked: false
                    }
                },
                messageHelper.getSuccessMessageAction("flashMessage.savedLogArchive")
            ];
        case handlers.HELPER_PREPARE_LOG_FILE:
            if (response.result !== resultCodes.HELPER_RESULT_OK) {
                return [
                    messageHelper.getHelperFlashMessage(response),
                    {
                        type: actionTypes.SET_BLOCKED_UI,
                        payload: {
                            blocked: false
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.HELPER_SAVE_TOTAL_LOG_ARCHIVE_LENGTH,
                    payload: {
                        totalLength: response.data.length
                    }
                },
                {
                    type: actionTypes.HELPER_SAVE_LOG_ARCHIVE_PATH,
                    payload: {
                        logArchivePath: windowService.getTempPathForCustomFileName(
                            formatHelper.formatFileName("LOG", "zip")
                        )
                    }
                },
                {
                    type: actionTypes.HELPER_SAVE_DOWNLOADED_LOG_ARCHIVE_LENGTH,
                    payload: {
                        downloadedLength:
                            response.data.length > helper.HELPER_CHUNK_SIZE
                                ? helper.HELPER_CHUNK_SIZE
                                : response.data.length
                    }
                },
                {
                    type: actionTypes.HELPER_REQUEST,
                    payload: {
                        type: methods.METHOD_HELPER_GET_PREPARED_LOG_ARCHIVE,
                        params: {
                            bytesFrom: 0,
                            bytesTo:
                                response.data.length > helper.HELPER_CHUNK_SIZE
                                    ? helper.HELPER_CHUNK_SIZE
                                    : response.data.length
                        }
                    },
                    method: handlers.HELPER_GET_PREPARED_LOG_ARCHIVE,
                    tabId: 0
                }
            ];
        case handlers.HELPER_GET_PREPARED_LOG_ARCHIVE:
            if (response.result !== resultCodes.HELPER_RESULT_OK) {
                return [
                    messageHelper.getHelperFlashMessage(response),
                    {
                        type: actionTypes.SET_BLOCKED_UI,
                        payload: {
                            blocked: false
                        }
                    }
                ];
            }

            windowService.appendFileData(state.helper.logArchivePath, response.data, (error) => {
                if (error === null) {
                    window.storeProvider.dispatchAction({
                        type: actionTypes.HELPER_PREPARE_FILE_SUCCESS
                    });
                } else {
                    windowService.logError("Download error ", error.message);

                    window.storeProvider.dispatchAction({
                        type: actionTypes.HELPER_PREPARE_FILE_ERROR
                    });
                }
            });

            return [];
        case handlers.HELPER_RELEASE_LOG_ARCHIVE:
            if (response.result !== resultCodes.HELPER_RESULT_OK) {
                return [
                    messageHelper.getHelperFlashMessage(response),
                    {
                        type: actionTypes.SET_BLOCKED_UI,
                        payload: {
                            blocked: false
                        }
                    }
                ];
            }

            windowService.openMoveFileDialog(state.helper.logArchivePath, formatHelper.formatFileName("LOG", "zip"));

            return [
                messageHelper.getSuccessMessageAction("flashMessage.logFileArchiveDownloadComplete"),
                {
                    type: actionTypes.HELPER_RESET_LOG_ARCHIVE_PARAMETERS
                },
                {
                    type: actionTypes.SET_BLOCKED_UI,
                    payload: {
                        blocked: false
                    }
                }
            ];
        case handlers.HELPER_DIALOG_BUTTON_CLICK:
            if (response.result !== resultCodes.HELPER_RESULT_OK) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            return [];
        case handlers.HELPER_RESTART_SERVER:
            if (response.result !== resultCodes.HELPER_RESULT_OK) {
                return [messageHelper.getHelperFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.RESET_SERVER_CONNECTION
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_HELPER_ACTION
                }
            ];
    }
};
